import {
  ErrorMessage,
  Field,
  FieldArray,
  useFormik,
  useFormikContext,
} from "formik";
import React, { useEffect, useState } from "react";
import TextError from "../../Components/HealthInsFormikComponent/TextError";
import DatePicker from "../../Components/DatePickers/DatePicker";

const QuickFieldArray = ({ formik }) => {
  const { values, setFieldValue } = useFormikContext();
  const [arrayObject, setArrayObject] = useState({});
  const [ageOptions, setAgeOptions] = useState([]);
  //console.log('eerr', formik)
  const childOption = [
    {
      value: "",
      label: "Select Age",
    },
    {
      value: "6 Month",
      label: "0-1 year",
    },
    {
      value: "1",
      label: "1 year",
    },
    {
      value: "2",
      label: "2 year",
    },
    {
      value: "3",
      label: "3 year",
    },
    {
      value: "4",
      label: "4 year",
    },
    {
      value: "5",
      label: "5 year",
    },
    {
      value: "6",
      label: "6 year",
    },
    {
      value: "7",
      label: "7 year",
    },
    {
      value: "8",
      label: "8 year",
    },
    {
      value: "9",
      label: "9 year",
    },
    {
      value: "10",
      label: "10 year",
    },
    {
      value: "11",
      label: "11 year",
    },
    {
      value: "12",
      label: "12 year",
    },
    {
      value: "13",
      label: "13 year",
    },
    {
      value: "14",
      label: "14 year",
    },
    {
      value: "15",
      label: "15 year",
    },
    {
      value: "16",
      label: "16 year",
    },
    {
      value: "17",
      label: "17 year",
    },
    {
      value: "18",
      label: "18 year",
    },
    {
      value: "19",
      label: "19 year",
    },
    {
      value: "20",
      label: "20 year",
    },
    {
      value: "21",
      label: "21 year",
    },
    {
      value: "22",
      label: "22 year",
    },
    {
      value: "23",
      label: "23 year",
    },
    {
      value: "24",
      label: "24 year",
    },
    {
      value: "25",
      label: "25 year",
    },
  ];

  const adultOption = [
    {
      value: "",
      label: "Select Age",
    },
    {
      value: "18",
      label: "18 year",
    },
    {
      value: "19",
      label: "19 year",
    },
    {
      value: "20",
      label: "20 year",
    },
    {
      value: "21",
      label: "21 year",
    },
    {
      value: "22",
      label: "22 year",
    },
    {
      value: "23",
      label: "23 year",
    },
    {
      value: "24",
      label: "24 year",
    },
    {
      value: "25",
      label: "25 year",
    },
    {
      value: "26",
      label: "26 year",
    },
    {
      value: "27",
      label: "27 year",
    },
    {
      value: "28",
      label: "28 year",
    },
    {
      value: "29",
      label: "29 year",
    },
    {
      value: "30",
      label: "30 year",
    },
    {
      value: "31",
      label: "31 year",
    },
    {
      value: "32",
      label: "32 year",
    },
    {
      value: "33",
      label: "33 year",
    },
    {
      value: "34",
      label: "34 year",
    },
    {
      value: "35",
      label: "35 year",
    },
    {
      value: "36",
      label: "36 year",
    },
    {
      value: "37",
      label: "37 year",
    },
    {
      value: "38",
      label: "38 year",
    },
    {
      value: "39",
      label: "39 year",
    },
    {
      value: "40",
      label: "40 year",
    },
    {
      value: "41",
      label: "41 year",
    },
    {
      value: "42",
      label: "42 year",
    },
    {
      value: "43",
      label: "43 year",
    },
    {
      value: "44",
      label: "44 year",
    },
    {
      value: "45",
      label: "45 year",
    },
    {
      value: "46",
      label: "46 year",
    },
    {
      value: "47",
      label: "47 year",
    },
    {
      value: "48",
      label: "48 year",
    },
    {
      value: "49",
      label: "49 year",
    },
    {
      value: "50",
      label: "50 year",
    },
    {
      value: "51",
      label: "51 year",
    },
    {
      value: "52",
      label: "52 year",
    },
    {
      value: "53",
      label: "53 year",
    },
    {
      value: "54",
      label: "54 year",
    },
    {
      value: "55",
      label: "55 year",
    },
    {
      value: "56",
      label: "56 year",
    },
    {
      value: "57",
      label: "57 year",
    },
    {
      value: "58",
      label: "58 year",
    },
    {
      value: "59",
      label: "59 year",
    },
    {
      value: "60",
      label: "60 year",
    },
    {
      value: "61",
      label: "61 year",
    },
    {
      value: "62",
      label: "62 year",
    },
    {
      value: "63",
      label: "63 year",
    },
    {
      value: "64",
      label: "64 year",
    },
    {
      value: "65",
      label: "65 year",
    },
    {
      value: "66",
      label: "66 year",
    },
    {
      value: "67",
      label: "67 year",
    },
    {
      value: "68",
      label: "68 year",
    },
    {
      value: "69",
      label: "69 year",
    },
    {
      value: "70",
      label: "70 year",
    },
    {
      value: "71",
      label: "71 year",
    },
    {
      value: "72",
      label: "72 year",
    },
    {
      value: "73",
      label: "73 year",
    },
    {
      value: "74",
      label: "74 year",
    },
    {
      value: "75",
      label: "75 year",
    },
    {
      value: "76",
      label: "76 year",
    },
    {
      value: "77",
      label: "77 year",
    },
    {
      value: "78",
      label: "78 year",
    },
    {
      value: "79",
      label: "79 year",
    },
    {
      value: "80",
      label: "80 year",
    },
    {
      value: "81",
      label: "81 year",
    },
    {
      value: "82",
      label: "82 year",
    },
    {
      value: "83",
      label: "83 year",
    },
    {
      value: "84",
      label: "84 year",
    },
    {
      value: "85",
      label: "85 year",
    },
    {
      value: "86",
      label: "86 year",
    },
    {
      value: "87",
      label: "87 year",
    },
    {
      value: "88",
      label: "88 year",
    },
    {
      value: "89",
      label: "89 year",
    },
    {
      value: "90",
      label: "90 year",
    },
    {
      value: "91",
      label: "91 year",
    },
    {
      value: "92",
      label: "92 year",
    },
    {
      value: "93",
      label: "93 year",
    },
    {
      value: "94",
      label: "94 year",
    },
    {
      value: "95",
      label: "95 year",
    },
    {
      value: "96",
      label: "96 year",
    },
    {
      value: "97",
      label: "97 year",
    },
    {
      value: "98",
      label: "98 year",
    },
    {
      value: "99",
      label: "99 year",
    },
  ];

  const adultOption2 = [
    {
      value: "",
      label: "Select Age",
    },
    {
      value: "18",
      label: "18 year",
    },
    {
      value: "19",
      label: "19 year",
    },
    {
      value: "20",
      label: "20 year",
    },
    {
      value: "21",
      label: "21 year",
    },
    {
      value: "22",
      label: "22 year",
    },
    {
      value: "23",
      label: "23 year",
    },
    {
      value: "24",
      label: "24 year",
    },
    {
      value: "25",
      label: "25 year",
    },
    {
      value: "26",
      label: "26 year",
    },
    {
      value: "27",
      label: "27 year",
    },
    {
      value: "28",
      label: "28 year",
    },
    {
      value: "29",
      label: "29 year",
    },
    {
      value: "30",
      label: "30 year",
    },
    {
      value: "31",
      label: "31 year",
    },
    {
      value: "32",
      label: "32 year",
    },
    {
      value: "33",
      label: "33 year",
    },
    {
      value: "34",
      label: "34 year",
    },
    {
      value: "35",
      label: "35 year",
    },
    {
      value: "36",
      label: "36 year",
    },
    {
      value: "37",
      label: "37 year",
    },
    {
      value: "38",
      label: "38 year",
    },
    {
      value: "39",
      label: "39 year",
    },
    {
      value: "40",
      label: "40 year",
    },
    {
      value: "41",
      label: "41 year",
    },
    {
      value: "42",
      label: "42 year",
    },
    {
      value: "43",
      label: "43 year",
    },
    {
      value: "44",
      label: "44 year",
    },
    {
      value: "45",
      label: "45 year",
    },
    {
      value: "46",
      label: "46 year",
    },
    {
      value: "47",
      label: "47 year",
    },
    {
      value: "48",
      label: "48 year",
    },
    {
      value: "49",
      label: "49 year",
    },
    {
      value: "50",
      label: "50 year",
    },
    {
      value: "51",
      label: "51 year",
    },
    {
      value: "52",
      label: "52 year",
    },
    {
      value: "53",
      label: "53 year",
    },
    {
      value: "54",
      label: "54 year",
    },
    {
      value: "55",
      label: "55 year",
    },
    {
      value: "56",
      label: "56 year",
    },
    {
      value: "57",
      label: "57 year",
    },
    {
      value: "58",
      label: "58 year",
    },
    {
      value: "59",
      label: "59 year",
    },
    {
      value: "60",
      label: "60 year",
    },
    {
      value: "61",
      label: "61 year",
    },
    {
      value: "62",
      label: "62 year",
    },
    {
      value: "63",
      label: "63 year",
    },
    {
      value: "64",
      label: "64 year",
    },
    {
      value: "65",
      label: "65 year",
    },
    {
      value: "66",
      label: "66 year",
    },
    {
      value: "67",
      label: "67 year",
    },
    {
      value: "68",
      label: "68 year",
    },
    {
      value: "69",
      label: "69 year",
    },
    {
      value: "70",
      label: "70 year",
    },
    {
      value: "71",
      label: "71 year",
    },
    {
      value: "72",
      label: "72 year",
    },
    {
      value: "73",
      label: "73 year",
    },
    {
      value: "74",
      label: "74 year",
    },
    {
      value: "75",
      label: "75 year",
    },
    {
      value: "76",
      label: "76 year",
    },
    {
      value: "77",
      label: "77 year",
    },
    {
      value: "78",
      label: "78 year",
    },
    {
      value: "79",
      label: "79 year",
    },
    {
      value: "80",
      label: "80 year",
    },
    {
      value: "81",
      label: "81 year",
    },
    {
      value: "82",
      label: "82 year",
    },
    {
      value: "83",
      label: "83 year",
    },
    {
      value: "84",
      label: "84 year",
    },
    {
      value: "85",
      label: "85 year",
    },
    {
      value: "86",
      label: "86 year",
    },
    {
      value: "87",
      label: "87 year",
    },
    {
      value: "88",
      label: "88 year",
    },
    {
      value: "89",
      label: "89 year",
    },
    {
      value: "90",
      label: "90 year",
    },
    {
      value: "91",
      label: "91 year",
    },
    {
      value: "92",
      label: "92 year",
    },
    {
      value: "93",
      label: "93 year",
    },
    {
      value: "94",
      label: "94 year",
    },
    {
      value: "95",
      label: "95 year",
    },
    {
      value: "96",
      label: "96 year",
    },
    {
      value: "97",
      label: "97 year",
    },
    {
      value: "98",
      label: "98 year",
    },
  ];

  const adultOption3 = [
    {
      value: "",
      label: "Select Age",
    },
    {
      value: "18",
      label: "18 year",
    },
    {
      value: "19",
      label: "19 year",
    },
    {
      value: "20",
      label: "20 year",
    },
    {
      value: "21",
      label: "21 year",
    },
    {
      value: "22",
      label: "22 year",
    },
    {
      value: "23",
      label: "23 year",
    },
    {
      value: "24",
      label: "24 year",
    },
    {
      value: "25",
      label: "25 year",
    },
    {
      value: "26",
      label: "26 year",
    },
    {
      value: "27",
      label: "27 year",
    },
    {
      value: "28",
      label: "28 year",
    },
    {
      value: "29",
      label: "29 year",
    },
    {
      value: "30",
      label: "30 year",
    },
    {
      value: "31",
      label: "31 year",
    },
    {
      value: "32",
      label: "32 year",
    },
    {
      value: "33",
      label: "33 year",
    },
    {
      value: "34",
      label: "34 year",
    },
    {
      value: "35",
      label: "35 year",
    },
    {
      value: "36",
      label: "36 year",
    },
    {
      value: "37",
      label: "37 year",
    },
    {
      value: "38",
      label: "38 year",
    },
    {
      value: "39",
      label: "39 year",
    },
    {
      value: "40",
      label: "40 year",
    },
    {
      value: "41",
      label: "41 year",
    },
    {
      value: "42",
      label: "42 year",
    },
    {
      value: "43",
      label: "43 year",
    },
    {
      value: "44",
      label: "44 year",
    },
    {
      value: "45",
      label: "45 year",
    },
    {
      value: "46",
      label: "46 year",
    },
    {
      value: "47",
      label: "47 year",
    },
    {
      value: "48",
      label: "48 year",
    },
    {
      value: "49",
      label: "49 year",
    },
    {
      value: "50",
      label: "50 year",
    },
    {
      value: "51",
      label: "51 year",
    },
    {
      value: "52",
      label: "52 year",
    },
    {
      value: "53",
      label: "53 year",
    },
    {
      value: "54",
      label: "54 year",
    },
    {
      value: "55",
      label: "55 year",
    },
    {
      value: "56",
      label: "56 year",
    },
    {
      value: "57",
      label: "57 year",
    },
    {
      value: "58",
      label: "58 year",
    },
    {
      value: "59",
      label: "59 year",
    },
    {
      value: "60",
      label: "60 year",
    },
    {
      value: "61",
      label: "61 year",
    },
    {
      value: "62",
      label: "62 year",
    },
    {
      value: "63",
      label: "63 year",
    },
    {
      value: "64",
      label: "64 year",
    },
    {
      value: "65",
      label: "65 year",
    },
    {
      value: "66",
      label: "66 year",
    },
    {
      value: "67",
      label: "67 year",
    },
    {
      value: "68",
      label: "68 year",
    },
    {
      value: "69",
      label: "69 year",
    },
    {
      value: "70",
      label: "70 year",
    },
    {
      value: "71",
      label: "71 year",
    },
    {
      value: "72",
      label: "72 year",
    },
    {
      value: "73",
      label: "73 year",
    },
    {
      value: "74",
      label: "74 year",
    },
    {
      value: "75",
      label: "75 year",
    },
    {
      value: "76",
      label: "76 year",
    },
    {
      value: "77",
      label: "77 year",
    },
    {
      value: "78",
      label: "78 year",
    },
    {
      value: "79",
      label: "79 year",
    },
    {
      value: "80",
      label: "80 year",
    },
    {
      value: "81",
      label: "81 year",
    },
    {
      value: "82",
      label: "82 year",
    },
    {
      value: "83",
      label: "83 year",
    },
    {
      value: "84",
      label: "84 year",
    },
    {
      value: "85",
      label: "85 year",
    },
    {
      value: "86",
      label: "86 year",
    },
    {
      value: "87",
      label: "87 year",
    },
    {
      value: "88",
      label: "88 year",
    },
    {
      value: "89",
      label: "89 year",
    },
    {
      value: "90",
      label: "90 year",
    },
    {
      value: "91",
      label: "91 year",
    },
    {
      value: "92",
      label: "92 year",
    },
    {
      value: "93",
      label: "93 year",
    },
    {
      value: "94",
      label: "94 year",
    },
    {
      value: "95",
      label: "95 year",
    },
    {
      value: "96",
      label: "96 year",
    },
    {
      value: "97",
      label: "97 year",
    },
  ];

  const changeRelation = (val, index) => {
    console.log(
      "hhh",
      val.target.value,
      values.insureds[index].relationShip,
      index
    );
    let err = false;
    //formik.setFieldValue(`insureds[${index}][relationShip]`,val.target.value)
    values.insureds.map((insure) => {
      if (insure.relationShip === val.target.value) {
        //alert('err')
        err = true;
      }
    });
    if (err) {
      alert("err");
    } else {
      formik.setFieldValue(
        `insureds[${index}][relationShip]`,
        val.target.value
      );

      /*  if(formik.values.period ===''){
                alert('Please Provide period')
            } else{
                if(val.target.value === 'Dependent Child'){
                    formik.setFieldValue(`insureds[${index}][relationShip]`, val.target.value)
                    setAgeOptions(childOption)
    
                } else{
                    formik.values.period ==='1' ? setAgeOptions(adultOption) 
                    :formik.values.period ==='2' ? setAgeOptions(adultOption2)
                    :setAgeOptions(adultOption3)
                    formik.setFieldValue(`insureds[${index}][relationShip]`, val.target.value)
    
                }
            } */
    }
  };

  const handleChange = (val, index) => {
    //console.log('age val', typeof (val.target.value))
    if (val.target.value === "0-1") {
      setFieldValue(`insureds[${index}].Age`, "6 Month");
    } else {
      setFieldValue(`insureds[${index}].Age`, val.target.value);
    }
  };

  useEffect(() => {
    //console.log('value', values.insureds[0].relationShip)
    let custObject = values.insureds[0];
    Object.entries(custObject).map((entry) => {
      custObject = { ...custObject, [entry[0]]: "" };
    });

    // console.log('custObject', custObject)
    setArrayObject(custObject);
  }, [formik]);

  const handleInsuredMembers = (e, index) => {
    /*NOTE: onchange handler should be commented if we have 1 child combination product*/

    // console.log("value",e.target.value,index)
    // if(index ===0 && (e.target.value!=='Self' || e.target.value!=='Spouse'))
    if (Number(index) === 0 && e.target.value === "Dependent Child") {
      // setFieldValue(`insureds[${index}].relationShip`,"")
      formik.setFieldError(
        `insureds[${index}].relationShip`,
        "First member should be an adult"
      );
      formik.setFieldTouched(`insureds[${index}].relationShip`, true, false);
    } else {
      formik.handleChange(e);
    }
  };

  return (
    <>
      <div>
        <h4 className=" fw-bold HQ-title">Insured Persons</h4>
      </div>
      <FieldArray name="insureds">
        {({ push, remove }) => (
          <React.Fragment>
            {values.insureds &&
              values.insureds.length > 0 &&
              values.insureds.map((insure, index) => (
                <div key={index}>
                  <div className="form-group mb-3 ">
                    <label htmlFor="inputRelationShip" className="fw-bold">
                      Who would you like to get insured?
                    </label>
                    <Field
                      as="select"
                      name={`insureds[${index}].relationShip`}
                      id="inputRelationShip"
                      className={
                        formik.touched.insureds &&
                        formik.errors.insureds &&
                        formik.touched.insureds[index] &&
                        formik.errors.insureds[index] &&
                        formik.errors.insureds[index].relationShip
                          ? "errorStyle form-control bg-white"
                          : formik.touched.insureds &&
                            formik.errors.insureds &&
                            formik.touched.insureds[index] &&
                            formik.errors.insureds[index] &&
                            !formik.errors.insureds[index].relationShip &&
                            formik.touched.insureds[index].relationShip
                          ? "successField form-control bg-white"
                          : "form-control bg-white"
                      }
                      // disabled={values.insureds[index].relationShip !== '' ? true : false}
                      onChange={
                        (e) =>
                          handleInsuredMembers(
                            e,
                            index
                          ) /*NOTE: onchange handler should be commented if we have 1 child combination product*/
                      }
                    >
                      <option value="">Select Member</option>
                      <option value="Self">Self</option>
                      <option value="Spouse">Spouse</option>
                      <option value="Dependent Child">Dependent Child</option>
                      <option value="Dependent Parent(Father)">
                        Dependent Parent(Father)
                      </option>
                      <option value="Dependent Parent(Mother)">
                        Dependent Parent(Mother)
                      </option>
                      <option value="Dependent In Law(Father)">
                        Dependent In Law(Father)
                      </option>
                      <option value="Dependent In Law(Mother)">
                        Dependent In Law(Mother)
                      </option>
                      <option value="Others">Others</option>
                    </Field>
                    <ErrorMessage
                      name={`insureds[${index}].relationShip`}
                      component={TextError}
                    />
                  </div>
                  <div>
                    {values.insureds[index].relationShip !== "" ? (
                      <div>
                        {/*  <div className="mb-3">
                                                    <label htmlFor="inputDOB" className=" fw-light">{values.insureds[index].relationShip}(Date Of Birth)</label>
                                                    <Field type="Date" className="form-control bg-white" name={`insureds[${index}].DOB`} id="inputDOB" aria-describedby="nameHelp" />

                                                </div> */}
                        <div className="mb-3 ">
                          <label htmlFor="inputInsureName" className="fw-light">
                            {values.insureds[index].relationShip} (First Name)
                          </label>
                          <Field
                            type="text"
                            id="inputInsureName"
                            aria-describedby="nameHelp"
                            name={`insureds[${index}].name`}
                            className={
                              formik.touched.insureds &&
                              formik.errors.insureds &&
                              formik.touched.insureds[index] &&
                              formik.errors.insureds[index] &&
                              formik.errors.insureds[index].name
                                ? "errorStyle form-control bg-white"
                                : formik.touched.insureds &&
                                  formik.errors.insureds &&
                                  formik.touched.insureds[index] &&
                                  formik.errors.insureds[index] &&
                                  !formik.errors.insureds[index].name &&
                                  formik.touched.insureds[index].name
                                ? "successField form-control bg-white"
                                : "form-control bg-white"
                            }
                          />
                          <ErrorMessage
                            name={`insureds[${index}].name`}
                            component={TextError}
                          />
                        </div>

                        <div className="mb-3 ">
                          <label htmlFor="inputAge">
                            {values.insureds[index].relationShip} (Age)
                          </label>
                          <Field
                            as="select"
                            name={`insureds[${index}].Age`}
                            id="inputAge"
                            className={
                              formik.touched.insureds &&
                              formik.errors.insureds &&
                              formik.touched.insureds[index] &&
                              formik.errors.insureds[index] &&
                              formik.errors.insureds[index].Age
                                ? "errorStyle form-control bg-white"
                                : formik.touched.insureds &&
                                  formik.errors.insureds &&
                                  formik.touched.insureds[index] &&
                                  formik.errors.insureds[index] &&
                                  !formik.errors.insureds[index].Age &&
                                  formik.touched.insureds[index].Age
                                ? "successField form-control bg-white"
                                : "form-control bg-white"
                            }
                            //onChange={(val) => handleChange(val,index)}
                          >
                            {
                              /* (formik.values.insureds[index].relationShip === "Dependent Child" ? childOption : adultOption).map((option) => {
                                                                    return (
                                                                        <option value={option.value}>{option.label}</option>
                                                                    )

                                                                }) */
                              /* (ageOptions).map((option) => {
                                                                    return (
                                                                        <option value={option.value}>{option.label}</option>
                                                                    )

                                                                }) */

                              (formik.values.insureds[index].relationShip ===
                              "Dependent Child"
                                ? childOption
                                : formik.values.period === "1"
                                ? adultOption
                                : formik.values.period === "2"
                                ? adultOption2
                                : formik.values.period === "3"
                                ? adultOption3
                                : adultOption
                              ).map((option) => {
                                return (
                                  <option value={option.value}>
                                    {option.label}
                                  </option>
                                );
                              })
                            }
                          </Field>
                          <ErrorMessage
                            name={`insureds[${index}].Age`}
                            component={TextError}
                          />
                        </div>
                        <div className="mb-3 ">
                          <label htmlFor="inputInsuredDOB" className="fw-light">
                            {values.insureds[index].relationShip} (Date Of
                            Birth)
                          </label>
                          <Field
                            type="text"
                            id="inputInsuredDOB"
                            aria-describedby="nameHelp"
                            name={`insureds[${index}].DOB`}
                            className={
                              formik.touched.insureds &&
                              formik.errors.insureds &&
                              formik.touched.insureds[index] &&
                              formik.errors.insureds[index] &&
                              formik.errors.insureds[index].DOB
                                ? "errorStyle form-control bg-white"
                                : formik.touched.insureds &&
                                  formik.errors.insureds &&
                                  formik.touched.insureds[index] &&
                                  formik.errors.insureds[index] &&
                                  !formik.errors.insureds[index].DOB &&
                                  formik.touched.insureds[index].DOB
                                ? "successField form-control bg-white"
                                : "form-control bg-white"
                            }
                            component={({ field, form }) => (
                              <DatePicker
                                field={field}
                                form={form}
                                relationShip={
                                  values.insureds[index].relationShip
                                }
                              />
                            )}
                          />
                          <label htmlFor="inputInsuredDOB" className="fw-light">
                            Note: Date of Birth is applicable for some products
                            !
                          </label>
                          <ErrorMessage
                            name={`insureds[${index}].DOB`}
                            component={TextError}
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3 d-flex justify-content-end">
                    {values.insureds.length > 1 ? (
                      <p
                        type="button"
                        className=" text-danger"
                        onClick={() => remove(index)}
                      >
                        Remove
                      </p>
                    ) : null}
                  </div>
                </div>
              ))}
            {values.insureds[0].relationShip !== "" ? (
              <div className="mb-3 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-success text-dark"
                  onClick={() => push(arrayObject)}
                >
                  <i className="bi bi-plus"></i>
                  Add Members
                </button>
              </div>
            ) : null}
          </React.Fragment>
        )}
      </FieldArray>
    </>
  );
};

export default QuickFieldArray;
